import { useEffect, useState } from "react";
import CryptoJS from "crypto-js";

const getEncryptionKey = () => {
    let key = localStorage.getItem("key");
    if (!key) {
        key = CryptoJS.lib.WordArray.random(32).toString(CryptoJS.enc.Hex);
        localStorage.setItem("key", key);
    }
    return key;
};

const encrypt = (data, key) => {
    return CryptoJS.AES.encrypt(JSON.stringify(data), key).toString();
};

const decrypt = (data, key) => {
    const bytes = CryptoJS.AES.decrypt(data, key);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
};

export default function useCardsState() {
    const [cards, setCards]: any = useState([]);
    const key = getEncryptionKey();

    useEffect(() => {
        const storedCards = getFromStorage("cards");
        if (storedCards) {
            setCards(storedCards);
        }
    }, []);

    const getFromStorage = (name) => {
        const value = localStorage.getItem(name);
        return value ? decrypt(value, key) : null;
    };

    const setToStorage = (name, value) => {
        const encryptedData = encrypt(value, key);
        localStorage.setItem(name, encryptedData);
    };

    const saveCardsToStorage = (newCards) => {
        setToStorage("cards", newCards);
    };

    const getAll = () => {
        return new Promise((resolve) => {
            const storedCards = getFromStorage("cards") || [];
            resolve(storedCards);
        });
    };

    const add = (newCard) => {
        const updatedCards = [...cards, newCard];
        setCards(updatedCards);
        saveCardsToStorage(updatedCards);
    };

    const deleteRecord = (id) => {
        const updatedCards = cards.filter((card) => card.id !== id);
        setCards(updatedCards);
        saveCardsToStorage(updatedCards);
    };

    const getByIndex = (indexName, key) => {
        return cards.find((card) => card[indexName] === key);
    };

    const deleteByIndex = (indexName, key) => {
        if (indexName === "id") {
            return deleteRecord(parseInt(key));
        } else {
            const card = getByIndex(indexName, key);
            if (card) {
                return deleteRecord(card.id);
            }
        }
    };

    const clearAll = () => {
        setCards([]);
        localStorage.removeItem("cards");
    };

    const getByCardMaskedCLN = (cardMaskedCLN) => {
        return cards.find((card) => card.cardMaskedCLN === cardMaskedCLN);
    };

    const deleteByMaskedCLN = (maskedCLN) => {
        const updatedCards = cards.filter((card) => card.cardMaskedCLN !== maskedCLN);
        setCards(updatedCards);
        saveCardsToStorage(updatedCards);
    };

    return { cards, add, deleteRecord, getByIndex, deleteByIndex, clearAll, getByCardMaskedCLN, getAll, deleteByMaskedCLN };
}
